// import { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { useSelector } from "react-redux";
// import {
//   MapPin,
//   Globe,
//   Briefcase,
//   LogIn,
//   ArrowLeft,
// } from "lucide-react";
// import {
//   Dialog,
//   DialogContent,
//   DialogDescription,
//   DialogHeader,
//   DialogTitle,
// } from "@/components/ui/dialog";
// import { Button } from "@/components/ui/button";
// import Navbar from "./shared/Navbar";
// import useGetCompanyById from "@/hooks/useGetCompanyById";
// import PropTypes from "prop-types";
// import { JOB_API_END_POINT } from "@/utils/constant";

// const CompanyJobs = () => {
//   const { companyId } = useParams();
//   const [jobs, setJobs] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [showAuthModal, setShowAuthModal] = useState(false);
//   const { error } = useGetCompanyById(companyId);
//   const company = useSelector((state) => state.company.singleCompany);
//   const user = useSelector((state) => state.auth?.user);
//   const isAuthenticated = !!user;
//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchCompanyJobs();
//   }, [companyId]);

//   const fetchCompanyJobs = async () => {
//     try {
//       const response = await fetch(
//         `${JOB_API_END_POINT}/getCompanyJobs/${companyId}`
//       );
//       const data = await response.json();
//       if (data.success) {
//         setJobs(data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching jobs:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleViewDetails = (jobId) => {
//     if (!isAuthenticated) {
//       setShowAuthModal(true);
//       return;
//     }
//     navigate(`/description/${jobId}`);
//   };

//   const JobCard = ({ job }) => (
//     <div className="bg-white border border-gray-300 rounded-xl p-4 md:p-3 md:px-6 transition duration-300 hover:shadow-lg hover:border-blue-100 relative group">
//       <div className="flex items-start md:items-center mb-4 space-x-3 md:space-x-4 mt-2">
//         <div className="h-14 w-14 md:h-20 md:w-20 shrink-0 rounded-xl flex items-center justify-center">
//           {company?.logo ? (
//             <img
//               src={company.logo}
//               alt={`${company.CompanyName || "Company"} logo`}
//               className="w-full h-full object-contain rounded-lg"
//             />
//           ) : (
//             <div className="w-full h-full bg-gray-50 rounded-lg flex items-center justify-center">
//               <span className="text-gray-400 text-sm">Logo</span>
//             </div>
//           )}
//         </div>
//         <div className="flex-1 min-w-0">
//           <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-1 md:gap-2">
//             <h2 className="text-sm md:text-sm font-semibold text-[#949494] truncate">
//               {company?.CompanyName || company?.name || company || "Company Name"}
//             </h2>
//           </div>
//           <h1 className="text-base md:text-xl font-semibold text-gray-700">
//             {job?.title || "Position not specified"}
//           </h1>
//           <div className="flex items-center space-x-1 p-2 rounded-lg">
//             <MapPin className="w-4 h-4 md:w-5 md:h-5 text-[#012760]" />
//             <span className="text-xs text-gray-600 truncate">
//               {job?.location || "Location not specified"}
//             </span>
//           </div>
//         </div>
//       </div>

//       <div className="h-px bg-gray-300"></div>

//       <div className="grid grid-cols-1 sm:grid-cols-6 gap-2 mb-4 mt-3">
//         <div className="flex items-center space-x-2 bg-[#97C0FF] bg-opacity-25 p-2 rounded-lg justify-center">
//           <span className="text-xs text-[#444444] truncate">
//             {job?.salary ? `${job.salary}` : "Salary not specified"}
//           </span>
//         </div>
//         <div className="flex items-center space-x-2 bg-[#97C0FF] bg-opacity-25 p-2 rounded-lg justify-center">
//           <span className="text-xs text-[#444444] truncate">
//             {job?.jobType || "Job type not specified"}
//           </span>
//         </div>
//       </div>

//       <div>
//         <div className="flex gap-10">
//           <div className="mb-4 w-1/2 text-[#444444]">
//             {job?.description ? (
//               <div className="text-sm text-[#747474] line-clamp-2">
//                 {job.description}
//               </div>
//             ) : (
//               "No description available"
//             )}
//           </div>

//           <div className="ml-56 mt-6 flex flex-col sm:flex-row gap-2 sm:gap-3">
//             <button
//               onClick={() => handleViewDetails(job.jobId)}
//               className="text-m md:text-m w-full sm:w-auto underline text-[#012760]"
//             >
//               View Details
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   JobCard.propTypes = {
//     job: PropTypes.shape({
//       jobId: PropTypes.string.isRequired,
//       title: PropTypes.string.isRequired,
//       location: PropTypes.string,
//       jobType: PropTypes.string,
//       salary: PropTypes.string,
//       description: PropTypes.string,
//     }).isRequired,
//   };

//   if (isLoading) {
//     return (
//       <div className="min-h-screen bg-white flex items-center justify-center">
//         <div className="animate-spin rounded-full h-10 w-10 border-4 border-[#012760] border-t-transparent"></div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen bg-white flex items-center justify-center p-4">
//         <div className="text-red-600 text-center">Error loading company data</div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-white">
//       <Navbar />
//       <div className="max-w-4xl mx-auto py-6 md:py-12 px-4 mt-6">
//         <div className="bg-white p-6 md:p-8">
//           {/* Back Button */}
//           <button
//             onClick={() => navigate(-1)}
//             className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-9 group"
//           >
//             <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
//             <span className="text-m font-bold">Go back</span>
//           </button>

//           {/* Company Logo */}
//           {company && (
//             <div className="mb-4">
//               <img
//                 src={company.logo || "https://via.placeholder.com/100"}
//                 alt={company.CompanyName || "Company Logo"}
//                 className="w-20 h-20 rounded-lg object-contain border border-gray-200"
//               />
//             </div>
//           )}

//           {/* Company Name and Details */}
//           {company && (
//             <div className="mb-8">
//               <h1 className="text-4xl font-bold text-[#444444] mb-2">
//                 {company.CompanyName}
//               </h1>

//               {/* Location and Website */}
//               <div className="flex items-center gap-2 mb-4">
//                 <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg">
//                   <MapPin className="w-4 h-4 text-[#012760]" />
//                   <span className="text-[#949494] text-m">{company.location}</span>
//                 </div>
//                 {company.website && (
//                   <a
//                     href={company.website}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center gap-2 px-3 py-1.5 rounded-lg hover:bg-opacity-20 transition-all duration-300"
//                   >
//                     <Globe className="w-4 h-4 text-[#012760]" />
//                     <span className="text-[#949494] text-m">{company.website}</span>
//                   </a>
//                 )}
//               </div>

//               {/* Company Description */}
//               <div className="text-[#747474] text-sm leading-relaxed">
//                 {company.description}
//               </div>
//             </div>
//           )}

//           <div className="h-px bg-gray-200 w-full my-10"></div>

//           {/* Jobs Section */}
//           <div className="mb-4">
//             <h2 className="text-2xl font-bold text-[#444444]">
//               Jobs Posted ({jobs.length})
//             </h2>
//           </div>

//           {jobs.length > 0 ? (
//             <div className="grid grid-cols-1 gap-6">
//               {jobs.map((job) => (
//                 <JobCard key={job.jobId} job={job} />
//               ))}
//             </div>
//           ) : (
//             <div className="text-center py-12 bg-white rounded-xl border border-gray-200">
//               <Briefcase className="w-12 h-12 text-gray-400 mx-auto mb-4" />
//               <h3 className="text-[#444444] font-medium mb-2 text-xl">
//                 No open positions
//               </h3>
//               <p className="text-[#747474] text-sm">
//                 This company currently has no job listings
//               </p>
//             </div>
//           )}
//         </div>
//       </div>

//       <Dialog open={showAuthModal} onOpenChange={setShowAuthModal}>
//         <DialogContent className="sm:max-w-md mx-4">
//           <DialogHeader>
//             <DialogTitle className="text-lg md:text-xl font-semibold">
//               Sign in Required
//             </DialogTitle>
//             <DialogDescription className="text-gray-600 mt-2">
//               Please sign in to view job details and save jobs to your profile.
//             </DialogDescription>
//           </DialogHeader>
//           <div className="flex flex-col gap-4 py-4">
//             <p className="text-sm text-gray-500">
//               Create an account or sign in to access all features and apply to jobs.
//             </p>
//             <div className="flex flex-col sm:flex-row justify-end gap-3">
//               <Button
//                 variant="outline"
//                 onClick={() => setShowAuthModal(false)}
//                 className="w-full sm:w-auto"
//               >
//                 Cancel
//               </Button>
//               <Button
//                 className="w-full sm:w-auto bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white"
//                 onClick={() => {
//                   setShowAuthModal(false);
//                   navigate("/signup/candidate");
//                 }}
//               >
//                 <LogIn className="w-4 h-4 mr-2" />
//                 Sign Up
//               </Button>
//             </div>
//             <button
//               className="text-sm text-gray-600 hover:text-blue-600 hover:underline text-center sm:text-right"
//               onClick={() => navigate('/login')}
//             >
//               Already have an account? Sign in
//             </button>
//           </div>
//         </DialogContent>
//       </Dialog>
//     </div>
//   );
// };

// export default CompanyJobs;



import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import {
  MapPin, Globe, Users, Building2, Briefcase,
  ChevronLeft, ChevronRight, Search,
  Shield, HeartPulse, GraduationCap, Coffee, Monitor,
  TrendingUp, CheckCircle2, ExternalLink, XCircle,
  ChevronDown, Layers, Pencil,
} from "lucide-react";

import { JOB_API_END_POINT, APPLICATION_API_END_POINT, COMPANY_API_END_POINT } from "@/utils/constant";
import Navbar from "./shared/Navbar";
import Footer from "./Footer";
import Job from "./Job";

/* ─────────────────────────────────────────────
   Constants
───────────────────────────────────────────── */
const PAGE_SIZE = 10;

const BENEFIT_ICONS = {
  "Health insurance": <HeartPulse size={20} />,
  "Job/Soft skill training": <GraduationCap size={20} />,
  "Cafeteria": <Coffee size={20} />,
  "Professional degree assistance": <GraduationCap size={20} />,
  "Office gym": <Shield size={20} />,
  "Remote work": <Monitor size={20} />,
  "Performance bonus": <TrendingUp size={20} />,
};

/* ─────────────────────────────────────────────
   Rating Stars
───────────────────────────────────────────── */
const RatingStars = ({ rating }) => (
  <div className="flex items-center gap-0.5">
    {[1, 2, 3, 4, 5].map((star) => (
      <svg key={star} className="w-3.5 h-3.5" viewBox="0 0 20 20">
        <defs>
          <linearGradient id={`star-${star}`}>
            <stop
              offset={`${Math.min(100, Math.max(0, (rating - star + 1) * 100))}%`}
              stopColor="#f59e0b"
            />
            <stop
              offset={`${Math.min(100, Math.max(0, (rating - star + 1) * 100))}%`}
              stopColor="#d1d5db"
            />
          </linearGradient>
        </defs>
        <path
          d="M10 1l2.39 4.84 5.34.78-3.86 3.76.91 5.32L10 13.27l-4.78 2.51.91-5.32L2.27 6.62l5.34-.78z"
          fill={`url(#star-${star})`}
        />
      </svg>
    ))}
  </div>
);

/* ─────────────────────────────────────────────
   Main Component
───────────────────────────────────────────── */
export default function CompanyJobs() {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const u = useSelector((state) => state.auth?.user);

  const [company, setCompany] = useState(null);
  const [companyJobs, setCompanyJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [appliedJobIds, setAppliedJobIds] = useState(new Set());

  const [activeTab, setActiveTab] = useState("overview");
  const [search, setSearch] = useState("");
  const [jobTypeFilter, setJobTypeFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [companyLoading, setCompanyLoading] = useState(true);
  const [error, setError] = useState(null);


// Scroll to top on mount
useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
}, []);

  /* ── Fetch company details from API ── */
  useEffect(() => {
    if (!companyId) return;
    setCompanyLoading(true);

    axios
      .get(`${COMPANY_API_END_POINT}/get/${companyId}`, { withCredentials: true })
      .then((res) => {
        if (res.data.status && res.data.data) {
          setCompany(res.data.data);
        } else {
          setError("Failed to load company details.");
        }
      })
      .catch((err) => {
        console.error("Error fetching company:", err);
        setError("Failed to load company details.");
      })
      .finally(() => setCompanyLoading(false));
  }, [companyId]);

  /* ── Fetch company jobs from API ── */
  useEffect(() => {
    if (!companyId) return;
    setIsLoading(true);

    fetch(`${JOB_API_END_POINT}/getCompanyJobs/${companyId}`)
      .then((res) => res.json())
      .then((data) => {
        const jobs = data.success ? data.data : [];
        setCompanyJobs(jobs);
        setFilteredJobs(jobs);
      })
      .catch((err) => console.error("Error fetching jobs:", err))
      .finally(() => setIsLoading(false));
  }, [companyId]);

  /* ── Fetch applied job IDs (candidates only) ── */
  useEffect(() => {
    if (!u || u.role === "recruiter") return;
    axios
      .get(`${APPLICATION_API_END_POINT}/get`, { withCredentials: true })
      .then((res) => {
        if (res.data.status) {
          const ids = new Set(
            res.data.applications
              .map((a) => a?.job?.jobId || a?.job?._id || a?.jobId)
              .filter(Boolean)
          );
          setAppliedJobIds(ids);
        }
      })
      .catch(() => {});
  }, [u]);

  /* ── Search + filter jobs ── */
  useEffect(() => {
    let result = companyJobs;
    if (search) {
      const term = search.toLowerCase();
      result = result.filter(
        (j) =>
          j.title?.toLowerCase().includes(term) ||
          j.location?.toLowerCase().includes(term)
      );
    }
    if (jobTypeFilter) {
      result = result.filter((j) =>
        (j.jobType || []).some((t) =>
          t.toLowerCase().includes(jobTypeFilter.toLowerCase())
        )
      );
    }
    setFilteredJobs(result);
    setCurrentPage(1);
  }, [search, jobTypeFilter, companyJobs]);

  const totalPages = Math.ceil(filteredJobs.length / PAGE_SIZE) || 1;
  const paginatedJobs = filteredJobs.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  );

  /* ── Enriched data (real API fields with fallbacks) ── */
  const enriched = {
    rating: company?.rating || 3.8,
    reviewCount: company?.reviewCount || 987,
    tagline: company?.description || "A leading company driving innovation.",
    website: company?.website || "#",
    founded: company?.founded || "N/A",
    size: company?.size || "N/A",
    type: company?.type || "Private",
    headquarters: company?.location || "N/A",
    fields: company?.fields || [],
    benefits: company?.benefits || [
      "Health insurance",
      "Job/Soft skill training",
      "Remote work",
      "Performance bonus",
    ],
    about: company?.description || "No description available.",
  };

  /* ── Error state ── */
  if (error) {
    return (
      <div className="min-h-screen bg-[#f4f6fb]">
        <Navbar />
        <div className="flex items-center justify-center h-[60vh]">
          <p className="text-red-500 font-medium">{error}</p>
        </div>
        <Footer />
      </div>
    );
  }

  /* ── Full page loading ── */
  if (companyLoading) {
    return (
      <div className="min-h-screen bg-[#f4f6fb]">
        <Navbar />
        <div className="flex items-center justify-center h-[60vh]">
          <div className="w-10 h-10 rounded-full border-2 border-[#012760] border-t-transparent animate-spin" />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#f4f6fb]">
      <Navbar />

      {/* ── BANNER ── */}
      <div className="relative w-full h-56 md:h-72 bg-gray-200 overflow-hidden mt-16">
        <img
          src={
            company?.banner ||
            "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1600&q=80"
          }
          alt="Company Banner"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/60" />
      </div>

      {/* ── COMPANY IDENTITY CARD ── */}
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="relative bg-white rounded-2xl shadow-sm border border-gray-100 -mt-14 px-6 py-6 mb-6">
          <div className="flex flex-col md:flex-row md:items-start gap-5">

            {/* Logo */}
            <div className="flex-shrink-0 -mt-14 md:-mt-16">
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl border-4 border-white shadow-md bg-white overflow-hidden">
                <img
                  src={
                    company?.logo ||
                    "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                  }
                  alt="logo"
                  className="w-full h-full object-contain p-1"
                />
              </div>
            </div>

            {/* Info */}
            <div className="flex-1 min-w-0">
              <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                <div>
                  <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
                    {company?.CompanyName || "Company Name"}
                  </h1>
                  <p className="text-gray-500 text-sm mt-0.5">{enriched.tagline}</p>

                  {/* Rating */}
                  <div className="flex items-center gap-2 mt-2">
                    <RatingStars rating={enriched.rating} />
                    <span className="text-amber-500 font-bold text-sm">{enriched.rating}</span>
                    <span className="text-gray-400 text-xs">
                      ({enriched.reviewCount.toLocaleString()} reviews)
                    </span>
                  </div>
                </div>

                {/* CTA Buttons */}
                <div className="flex items-center gap-2 flex-shrink-0">
                  {/* Edit button — recruiters only */}
                  {u?.role === "recruiter" && (
                    <button
                      onClick={() =>
                        navigate(`/admin/companies/${company?.companyId}/edit`)
                      }
                      className="flex items-center gap-1.5 px-4 py-2 rounded-lg bg-[#012760] text-white text-sm font-semibold hover:bg-[#01184a] transition-colors"
                    >
                      <Pencil size={14} />
                      Edit Company
                    </button>
                  )}
                  
                  <a
                    href={enriched.website}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-1.5 px-4 py-2 rounded-lg border border-[#012760] text-[#012760] text-sm font-semibold hover:bg-[#012760] hover:text-white transition-colors"
                  >
                    <ExternalLink size={14} />
                    Visit Website
                  </a>
                </div>
              </div>

              {/* Tags / Fields */}
              {enriched.fields.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-3">
                  {enriched.fields.map((f) => (
                    <span
                      key={f}
                      className="px-3 py-1 rounded-full bg-blue-50 text-blue-700 text-xs font-medium border border-blue-100"
                    >
                      {f}
                    </span>
                  ))}
                </div>
              )}

              {/* Meta row */}
              <div className="flex flex-wrap items-center gap-4 mt-3 text-xs text-gray-500">
                <span className="flex items-center gap-1.5">
                  <MapPin size={13} className="text-[#012760]" />
                  {enriched.headquarters}
                </span>
                <span className="flex items-center gap-1.5">
                  <Users size={13} className="text-[#012760]" />
                  {enriched.size}
                </span>
                <span className="flex items-center gap-1.5">
                  <Building2 size={13} className="text-[#012760]" />
                  {enriched.type}
                </span>
                <span className="flex items-center gap-1.5">
                  <Globe size={13} className="text-[#012760]" />
                  Est. {enriched.founded}
                </span>
                <span className="flex items-center gap-1.5">
                  <Briefcase size={13} className="text-purple-500" />
                  <span className="font-semibold text-purple-600">{companyJobs.length}</span> open roles
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* ── TABS ── */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 mb-6">
          <div className="flex border-b border-gray-100">
            {["overview", "jobs"].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`relative px-8 py-4 text-sm font-semibold capitalize transition-colors
                  ${activeTab === tab
                    ? "text-[#012760]"
                    : "text-gray-400 hover:text-gray-600"
                  }`}
              >
                {tab === "jobs" ? `Jobs (${companyJobs.length})` : "Overview"}
                {activeTab === tab && (
                  <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#012760] rounded-full" />
                )}
              </button>
            ))}
          </div>
        </div>

        {/* ════════════════════════════════════════════════
            OVERVIEW TAB
        ════════════════════════════════════════════════ */}
        {activeTab === "overview" && (
          <div className="grid md:grid-cols-3 gap-6 pb-12">
            {/* LEFT */}
            <div className="md:col-span-2 space-y-6">

              {/* About */}
              <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
                <h2 className="text-base font-bold text-gray-900 mb-3">
                  About {company?.CompanyName}
                </h2>
                <p className="text-sm text-gray-600 leading-relaxed">{enriched.about}</p>
              </div>

              {/* Benefits */}
              <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-base font-bold text-gray-900">
                    Benefits reported by employees
                  </h2>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                  {enriched.benefits.map((b) => (
                    <div
                      key={b}
                      className="flex flex-col items-center gap-2 p-4 rounded-xl border border-gray-100 bg-gray-50 text-center hover:border-[#012760] hover:bg-blue-50/30 transition-all"
                    >
                      <span className="text-[#012760]">
                        {BENEFIT_ICONS[b] || <CheckCircle2 size={20} />}
                      </span>
                      <span className="text-xs font-medium text-gray-600 leading-tight">{b}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* RIGHT: Sidebar */}
            <div className="space-y-5">

              {/* Company Overview */}
              <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5 space-y-4">
                <h3 className="text-sm font-bold text-gray-900">Company Overview</h3>
                {[
                  { label: "Founded", value: enriched.founded, icon: <Building2 size={15} /> },
                  { label: "Headquarters", value: enriched.headquarters, icon: <MapPin size={15} /> },
                  { label: "Company size", value: enriched.size, icon: <Users size={15} /> },
                  { label: "Type", value: enriched.type, icon: <Layers size={15} /> },
                  { label: "Website", value: enriched.website, icon: <Globe size={15} />, link: true },
                ].map(({ label, value, icon, link }) => (
                  <div key={label} className="flex items-start gap-3">
                    <span className="text-[#012760] mt-0.5 flex-shrink-0">{icon}</span>
                    <div>
                      <p className="text-xs text-gray-400 font-medium">{label}</p>
                      {link ? (
                        <a
                          href={value}
                          target="_blank"
                          rel="noreferrer"
                          className="text-xs text-[#012760] font-semibold hover:underline break-all"
                        >
                          {value}
                        </a>
                      ) : (
                        <p className="text-xs text-gray-700 font-semibold">{value}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Open Roles CTA */}
              <div className="bg-[#012760] rounded-2xl p-5 text-white">
                <Briefcase size={22} className="mb-3 opacity-80" />
                <p className="font-bold text-lg">{companyJobs.length} Open Roles</p>
                <p className="text-xs text-blue-200 mt-1 mb-4">
                  Explore all current opportunities at {company?.CompanyName}
                </p>
                <button
                  onClick={() => setActiveTab("jobs")}
                  className="w-full py-2 rounded-xl bg-white text-[#012760] text-sm font-bold hover:bg-blue-50 transition-colors"
                >
                  View all jobs →
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ════════════════════════════════════════════════
            JOBS TAB
        ════════════════════════════════════════════════ */}
        {activeTab === "jobs" && (
          <div className="pb-12">
            {/* Search + filter bar */}
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4 mb-5 flex flex-col sm:flex-row gap-3">
              <div className="relative flex-1">
                <Search
                  size={15}
                  className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
                />
                <input
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search job title or location…"
                  className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg text-sm bg-white text-gray-800 placeholder-gray-400 outline-none focus:border-[#012760] focus:ring-2 focus:ring-[#012760]/10 transition-all"
                />
              </div>
              <select
                value={jobTypeFilter}
                onChange={(e) => setJobTypeFilter(e.target.value)}
                className="border border-gray-200 rounded-lg text-sm px-3 py-2.5 text-gray-600 bg-white focus:outline-none focus:ring-2 focus:ring-[#012760]/10 focus:border-[#012760]"
              >
                <option value="">All Types</option>
                {["Full-Time", "Part-Time", "Internship", "Contract", "Freelance", "Contract to Hire"].map((t) => (
                  <option key={t} value={t}>{t}</option>
                ))}
              </select>
              {(search || jobTypeFilter) && (
                <button
                  onClick={() => { setSearch(""); setJobTypeFilter(""); }}
                  className="flex items-center gap-1.5 text-xs text-gray-400 hover:text-red-500 transition-colors px-2"
                >
                  <XCircle size={14} /> Clear
                </button>
              )}
            </div>

            {/* Results count */}
            {!isLoading && (
              <p className="text-sm text-gray-500 mb-4">
                <span className="font-bold text-gray-800">{filteredJobs.length}</span> job
                {filteredJobs.length !== 1 ? "s" : ""} found
              </p>
            )}

            {/* Jobs list */}
            {isLoading ? (
              <div className="flex justify-center items-center h-48">
                <div className="w-8 h-8 rounded-full border-2 border-[#012760] border-t-transparent animate-spin" />
              </div>
            ) : paginatedJobs.length === 0 ? (
              <div className="bg-white rounded-2xl border border-gray-100 p-12 text-center shadow-sm">
                <Briefcase size={28} className="text-gray-300 mx-auto mb-3" />
                <p className="font-semibold text-gray-600">No jobs found</p>
                <p className="text-sm text-gray-400 mt-1">Try adjusting your search or filters</p>
              </div>
            ) : (
              <div className="space-y-3">
                {paginatedJobs.map((job) => {
                  const jobId = job?._id || job?.jobId?.S || job?.jobId;
                  return (
                    <div
                      key={jobId}
                      className="bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md hover:border-blue-100 transition-all duration-200"
                    >
                      <Job job={job} isApplied={appliedJobIds.has(jobId)} />
                    </div>
                  );
                })}
              </div>
            )}

            {/* Pagination */}
            {filteredJobs.length > PAGE_SIZE && (
              <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-6 pt-5 border-t border-gray-100">
                <p className="text-xs text-gray-400">
                  Showing{" "}
                  <span className="font-semibold text-gray-600">
                    {(currentPage - 1) * PAGE_SIZE + 1}–
                    {Math.min(currentPage * PAGE_SIZE, filteredJobs.length)}
                  </span>{" "}
                  of <span className="font-semibold text-gray-600">{filteredJobs.length}</span> jobs
                </p>
                <div className="flex items-center gap-1">
                  <button
                    onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                    disabled={currentPage === 1}
                    className={`w-8 h-8 rounded-lg border flex items-center justify-center transition-all
                      ${currentPage === 1
                        ? "border-gray-100 text-gray-300 cursor-not-allowed bg-gray-50"
                        : "border-gray-200 text-gray-600 hover:border-[#012760] hover:text-[#012760] bg-white"
                      }`}
                  >
                    <ChevronLeft size={16} />
                  </button>
                  <div className="px-3 py-1.5 rounded-lg bg-[#012760] text-white text-xs font-semibold min-w-[2.5rem] text-center">
                    {currentPage}
                  </div>
                  <span className="text-xs text-gray-400">of {totalPages}</span>
                  <button
                    onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                    disabled={currentPage === totalPages}
                    className={`w-8 h-8 rounded-lg border flex items-center justify-center transition-all
                      ${currentPage === totalPages
                        ? "border-gray-100 text-gray-300 cursor-not-allowed bg-gray-50"
                        : "border-gray-200 text-gray-600 hover:border-[#012760] hover:text-[#012760] bg-white"
                      }`}
                  >
                    <ChevronRight size={16} />
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}
